var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "p",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.locationUrlCode == 1,
            expression: "locationUrlCode == 1"
          }
        ],
        staticStyle: { "text-align": "center", "font-weight": "bold" }
      },
      [_vm._v("\n    拔河网隐私政策\n  ")]
    ),
    _vm._v(" "),
    _c(
      "p",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.locationUrlCode == 2,
            expression: "locationUrlCode == 2"
          }
        ],
        staticStyle: { "text-align": "center", "font-weight": "bold" }
      },
      [_vm._v("\n    拔河网用户协议\n  ")]
    ),
    _vm._v(" "),
    _c("div", { domProps: { innerHTML: _vm._s(_vm.yszcContent) } })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b0b9f62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b0b9f62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/policy/index.vue
// module id = null
// module chunks = 